import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-345162b8")

_pushScopeId("data-v-345162b8")
const _hoisted_1 = {
  key: 1,
  class: "circular-border"
}
const _hoisted_2 = {
  key: 3,
  class: "favorite-skeleton"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_establishments_list = _resolveComponent("header-establishments-list")
  const _component_select_location = _resolveComponent("select-location")
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")
  const _component_ion_refresher = _resolveComponent("ion-refresher")
  const _component_banner_list = _resolveComponent("banner-list")
  const _component_banner_list_skeleton = _resolveComponent("banner-list-skeleton")
  const _component_favorite_card_slide = _resolveComponent("favorite-card-slide")
  const _component_favorite_card_skeleton = _resolveComponent("favorite-card-skeleton")
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")
  const _component_establishment_card_skeleton = _resolveComponent("establishment-card-skeleton")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_establishment_card = _resolveComponent("establishment-card")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_network_error = _resolveComponent("network-error")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_establishments_list, {
            neighborhood: _ctx.neighborhoodState,
            user: _ctx.user,
            class: "header"
          }, null, 8, ["neighborhood", "user"]),
          (!_ctx.neighborhoodState?.id)
            ? (_openBlock(), _createBlock(_component_select_location, {
                key: 0,
                class: "circular-border"
              }))
            : (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_ion_refresher, {
                  slot: "fixed",
                  "close-duration": "1000",
                  "pull-min": "40",
                  onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doRefresh($event)))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_refresher_content)
                  ]),
                  _: 1
                }),
                (!_ctx.loadingRef)
                  ? (_openBlock(), _createBlock(_component_banner_list, {
                      key: 0,
                      banners: _ctx.bannersRef
                    }, null, 8, ["banners"]))
                  : (_openBlock(), _createBlock(_component_banner_list_skeleton, { key: 1 })),
                (!_ctx.loadingRef && _ctx.hasFavoritesRef)
                  ? (_openBlock(), _createBlock(_component_favorite_card_slide, {
                      key: 2,
                      favorites: _ctx.favoritesRef
                    }, null, 8, ["favorites"]))
                  : (_ctx.loadingRef)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, [
                        (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (i) => {
                          return _createVNode(_component_favorite_card_skeleton, { key: i })
                        }), 64))
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.loadingRef)
                  ? (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                      key: 4,
                      animated: "",
                      class: "banner-link-skeleton"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.bannerLinkRef && !_ctx.loadingRef)
                  ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                      key: 5,
                      class: "banner-link",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink(_ctx.bannerLinkRef.link)))
                    }, {
                      default: _withId(() => [
                        (_ctx.bannerLinkRef.image)
                          ? (_openBlock(), _createBlock(_component_ion_img, {
                              key: 0,
                              src: `https://storage.googleapis.com/thelivery/img/banners/${_ctx.bannerLinkRef.image}`
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.loadingRef)
                  ? (_openBlock(), _createBlock(_component_ion_grid, { key: 6 }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withId(() => [
                            (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (i) => {
                              return _createVNode(_component_ion_col, {
                                key: i,
                                class: "no-padding",
                                "size-xs": "12",
                                "size-sm": "12",
                                "size-md": "6",
                                "size-lg": "6",
                                "size-xl": "4"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_establishment_card_skeleton)
                                ]),
                                _: 2
                              }, 1024)
                            }), 64))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (!_ctx.occurredErrorRef)
                    ? (_openBlock(), _createBlock(_component_ion_grid, { key: 7 }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.establishmentsRef, (establishment) => {
                                return (_openBlock(), _createBlock(_component_ion_col, {
                                  key: establishment.id,
                                  class: "no-padding",
                                  "size-xs": "12",
                                  "size-sm": "12",
                                  "size-md": "6",
                                  "size-lg": "6",
                                  "size-xl": "4",
                                  onClick: ($event: any) => (
                _ctx.goToEstablishment(
                  establishment.slug,
                  _ctx.slugify(establishment.category)
                )
              )
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_establishment_card, { establishment: establishment }, null, 8, ["establishment"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_infinite_scroll, {
                            onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getNextEstablishments($event)))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_infinite_scroll_content, { "loading-ref-spinner": "dots" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_network_error, {
                        key: 8,
                        refresh: _ctx.getEstablishments
                      }, null, 8, ["refresh"]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})